import { CoverPage } from "./templates/CoverPage";
import { AdPage } from "./templates/AdPage";
import { ContentsPage } from "./templates/ContentsPage";
import { LetterPage, OpenerPage, ArticlePage, ClosingPage } from "./templates/TextPages";
import { PortraitPage, SectionOpenerPage, EssayPage, DiaryPage, CardsPage } from "./templates/VisualPages";
import { InterviewPage, ListPage } from "./templates/InterviewPage";

const TEMPLATES = {
  cover: CoverPage, ad: AdPage, contents: ContentsPage, letter: LetterPage, portrait: PortraitPage,
  opener: OpenerPage, section_opener: SectionOpenerPage, interview: InterviewPage, article: ArticlePage,
  essay: EssayPage, diary: DiaryPage, cards: CardsPage, list: ListPage, closing: ClosingPage,
};

export const PAGE_W = 600;
export const PAGE_H = 848;

export const MagazinePage = ({ page }) => {
  const Tpl = TEMPLATES[page.template] || ArticlePage;
  return <Tpl page={page} />;
};
